import { ReactElement } from "react";
import {
	DimensionRecommendation,
	SupportedImageInfo
} from "../SupportedImageInfo/SupportedImageInfo";
import styles from "./ImageSelectionPlaceholder.module.less";
import { setTrackingId } from "client/Misc/utils";
import { Icon } from "../Icon/Icon";
import classNames from "classnames";

export type ImageSelectionPlaceholderProps = {
	trackingId: string;
} & ({
	kind: "default";
	title: string | ReactElement;
	supportedFormats: readonly string[];
	maxFileSize: number | nil;
	dimensionRecommendation: DimensionRecommendation;
	svgMaxSize?: number;
	trackingId: string;
} | {
	kind: "error";
});

export const ImageSelectionPlaceholder = (props: ImageSelectionPlaceholderProps): ReactElement => {
	const { trackingId } = props;

	if (props.kind === "error") {
		return (
			<div
				{...setTrackingId(trackingId)}
				className={classNames(
					styles.root,
					styles.root_hasError
				)}
			>
				<div className={styles.icon}>
					<Icon
						value={{
							kind: "svg",
							name: "jpeg"
						}}
					/>
				</div>
			</div>
		);
	}

	const {
		dimensionRecommendation,
		maxFileSize,
		supportedFormats,
		title,
		svgMaxSize
	} = props;

	return (
		<div
			{...setTrackingId(trackingId)}
			className={styles.root}
		>
			<div className={styles.icon}>
				<Icon value="upload" />
			</div>
			<p className={styles.title}>
				{title}
			</p>
			<SupportedImageInfo
				maxFileSize={maxFileSize}
				dimensionRecommendation={dimensionRecommendation}
				supportedFormats={supportedFormats}
				svgMaxSize={svgMaxSize}
			/>
		</div>
	);
};
ImageSelectionPlaceholder.displayName = "ImageSelectionPlaceholder";